import style from './style';
import { useEffect, useState } from 'preact/hooks'

const Video = props => {
    const { site } = props;
    const [loadPlayer, setLoadPlayer] = useState(false);
    const [playerReady, setPlayerReady] = useState(false);
    const [player, setPlayer] = useState(undefined);

    useEffect(() => {
        if (!window.YT) { // If not, load the script asynchronously
            const tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            
            // onYouTubeIframeAPIReady will load the video after the script is loaded
            // window.onYouTubeIframeAPIReady = loadVideo;
            
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
    }, []);

    const loadVideo = () => {
        setLoadPlayer(true);
        const p = new window.YT.Player(`youtube-player`, {
            videoId: props.id,
            width: '100%',
            events: {
                onReady: () => {
                    setPlayerReady(true);
                    p.playVideo();
                },
            },
            playerVars: {
                controls: 1,
                fs: 1,
                iv_load_policy: 3,
                modestbranding: 1,
            }
        });
        setPlayer(p);
    };

    const fullScreen = () => {
        if (!playerReady) {
            return;
        }
        
        var requestFullScreen = player.a.requestFullScreen || player.a.mozRequestFullScreen || player.a.webkitRequestFullScreen;
        if (requestFullScreen) {
            requestFullScreen.bind(player.a)();
        }
    }

    return (
        <div className={`${style['video-wrapper']} ${style[`video-wrapper--${props.site}`]}`}>
            <div className={`${style['video__title']} ${style[`video__title--${props.site}`]}`} onClick={() => {
                playerReady
                    ? player.playVideo()
                    : loadVideo()
            }}>
                HolyWar_the_Story_of_Runet-episode_{site}.avi
            </div>
            { (!loadPlayer) && <div class={`${style['video__placeholder']} ${style[`video__placeholder--${props.site}`]}`} onClick={() => loadVideo()}/> }
            <div id={`youtube-player`}/>
            <div class={`${style['video__player-buttons']} ${style[`video__player-buttons--${site}`]}`}>
                <div
                    class={`${style['player__button-play']} ${style[`player__button--${site}`]}`}
                    onClick={() => {
                        playerReady
                            ? player.playVideo()
                            : loadVideo()
                    }}
                >
                    >проиграть
                </div>
                <div
                    class={`${style['player__button-pause']} ${style[`player__button--${site}`]} ${!playerReady ? style['not-playing'] : null}`}
                    onClick={() => player.getPlayerState() === 2 ? player.playVideo() : player.pauseVideo()}
                >
                    >на паузу
                </div>
                <div
                    class={`${style['player__button-stop']} ${style[`player__button--${site}`]} ${!playerReady ? style['not-playing'] : null} `}
                    onClick={() => player.stopVideo()}
                >
                    >стоп
                </div>
                <div
                    class={`${style['player__button-fullscreen']} ${style[`player__button--${site}`]} ${!playerReady ? style['not-playing'] : null}`}
                    onClick={() => fullScreen()}
                >
                    >весь экран
                </div>
            </div>
        </div>
    );
};


export default Video;
